var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('AccountTabs'),_c('PasswordForm',{attrs:{"embedded":true}}),_c('PasswordSecurityForm',{attrs:{"embedded":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }